import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  
  return (
    <footer className="relative bg-black" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">Footer</h2>
      
      {/* Top border gradient */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-purple-500/30 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6">
        <div className="text-center">
          <div className="text-white font-bold text-2xl mb-2">Parlando</div>
          <p className="text-gray-400 text-sm leading-6 max-w-md mx-auto mb-6">
            LIVE YOUR VERSE
          </p>
        </div>
        
        <div className="pt-4 border-t border-gray-800">
          <div className="flex flex-col items-center space-y-4">
            <div className="flex space-x-6">
              <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors">
                Terms of Service
              </Link>
            </div>
            <p className="text-gray-400 text-sm text-center">
              &copy; {year} Parlascape Ltd. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 